import { UPDATE_AFFILIATE } from "../actionTypes";

const INITIAL_STATE = {
  org: "",
  sync: "",
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_AFFILIATE:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
